module.exports = __webpack_public_path__ + "img/product12_login.53943809.jpg";